import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import DetailRow from "../CustomComponents/DetailRow";
import UserAvatar from "../CustomComponents/UserAvatar";
import ZoomImage from "../ZoomImage";

const DetailPollModal = ({
  handleEditModalClose,
  editData,
  isSuggested = false,
}) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  // Safe date formatter
  const formatDate = (date) => {
    if (!date) return "N/A";
    try {
      return new Date(date).toLocaleString();
    } catch {
      return "N/A";
    }
  };

  return (
    <ModalContainer handleClose={handleEditModalClose}>
      <div className={cssStyles.modalContainer} style={{ maxWidth: "90%" }}>
        {/* Header */}
        <div className="d-flex align-items-center w-100 justify-content-between mb-4">
          <p className="fs-4 fw-medium m-0 ">
            {isSuggested ? "Suggested Poll Details" : "Poll Details"}
          </p>
          <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
            <FaCircleXmark
              role="button"
              onClick={handleEditModalClose}
              style={{ cursor: "pointer" }}
            />
          </span>
        </div>

        {/* Body */}
        <div className="w-100">
          <Row className="g-5">
            {/* Left Side - Poll Info */}
            <Col sm={12} md={6}>
              <div className="d-flex flex-column align-items-center mb-4">
                <UserAvatar
                  image_url={editData?.owner?.image_url}
                  username={`${editData?.owner?.firstname || ""} ${
                    editData?.owner?.lastname || ""
                  }`}
                  size={90}
                />
                <p className="fw-bold mt-2">
                  {editData?.owner?.firstname || "N/A"}{" "}
                  {editData?.owner?.lastname || ""}
                </p>
              </div>

              <DetailRow title="Topic" value={editData?.topic || "N/A"} />
              <DetailRow
                title="Description"
                value={editData?.description || "N/A"}
              />
              <DetailRow
                title="Category"
                value={editData?.category?.name || "N/A"}
              />
              {isSuggested ? null : (
                <>
                  <DetailRow
                    title="Start Date"
                    value={formatDate(editData?.start_at)}
                  />
                  <DetailRow
                    title="End Date"
                    value={formatDate(editData?.end_at)}
                  />
                </>
              )}
            </Col>

            {/* Right Side - Poll Stats */}
            <Col sm={12} md={6}>
              <DetailRow
                title="Total Likes"
                value={editData?.total_likes ?? "N/A"}
              />
              <DetailRow
                title="Total Dislikes"
                value={editData?.total_dislikes ?? "N/A"}
              />
              <DetailRow
                title="Total Comments"
                value={editData?.total_comments ?? "N/A"}
              />
              <DetailRow
                title="Total Saved"
                value={editData?.total_saved ?? "N/A"}
              />
              {isSuggested ? null : (
                <DetailRow
                  title="Status"
                  value={editData?.status === 20 ? "Active" : "Closed"}
                />
              )}
            </Col>
          </Row>

          <Row>
            <Col sm={12} md={6}>
              {/* Options */}
              <div className="mt-4">
                <p className="fw-bold fs-5">Poll Options</p>
                {editData?.options?.length > 0 ? (
                  editData.options.map((opt) => (
                    <DetailRow
                      key={opt.id}
                      title={opt.option}
                      value={`Votes: ${opt.total_votes ?? 0}`}
                    />
                  ))
                ) : (
                  <p className="text-muted">No options available</p>
                )}
              </div>
              {/* Attachments */}
              {editData?.attachments?.length > 0 && (
                <div className="mt-4">
                  <p className="fw-bold fs-5">Attachments</p>
                  <div className="d-flex flex-wrap gap-3">
                    {editData.attachments.map((file, idx) => (
                      <ZoomImage imageUrl={file.media_url} />
                      // <img
                      //   key={idx}
                      //   src={file.media_url}
                      //   alt="Poll Attachment"
                      //   style={{
                      //     maxWidth: "200px",
                      //     borderRadius: "10px",
                      //     border: "1px solid #ddd",
                      //   }}
                      // />
                    ))}
                  </div>
                </div>
              )}
            </Col>
            <Col sm={12} md={6}>
              {/* Comments */}
              {!isSuggested && editData?.comments?.length > 0 && (
                <div className="mt-4">
                  <p className="fw-bold fs-5">Comments</p>
                  {editData.comments.map((c) => (
                    <div
                      key={c.id}
                      className="d-flex align-items-center mb-3 p-2 border rounded-4"
                    >
                      <UserAvatar
                        image_url={c.poll_comment_user?.image_url}
                        username={`${c.poll_comment_user?.firstname || ""} ${
                          c.poll_comment_user?.lastname || ""
                        }`}
                        size={40}
                      />
                      <div className="ms-3">
                        <p className="m-0 fw-medium">
                          {c.poll_comment_user?.firstname || "User"}:{" "}
                          <span className="fw-normal">
                            {c.comment || "N/A"}
                          </span>
                        </p>
                        <small className="text-white-50 small">
                          {formatDate(c.createdAt)}
                        </small>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </Col>
          </Row>
        </div>
      </div>
    </ModalContainer>
  );
};

export default DetailPollModal;
